import styled from "@mui/material/styles/styled";
import { PickersDay } from "@mui/x-date-pickers";
import { Stack } from "../../../..";
const DatePickerHeader = styled(Stack)`
  padding: 0 12px;
  justify-content: center;
`;
const PickersDayWeekTypeStyled = styled(PickersDay)(({ theme, isSelected, isHovered, day }) => ({
  padding: "0!important",
  position: "relative",
  zIndex: "1",
  "&:hover, &:focus": {
    background: "none!important",
    outline: "none!important"
  },
  ...isSelected && {
    "&::before": {
      content: '""',
      zIndex: -2,
      backgroundColor: "var(--mui-palette-elevation3-main)",
      position: "absolute",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      borderRadius: "8px"
    },
    ...(day.day() === 0 || day.day() === 1) && {
      "&::after": {
        content: '""',
        zIndex: -1,
        backgroundColor: "var(--mui-palette-brand-main)",
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        borderRadius: "8px"
      }
    }
  },
  ...isHovered && {
    "&::before": {
      content: '""',
      backgroundColor: "var(--mui-palette-elevation3-main)",
      position: "absolute",
      zIndex: -2,
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      borderRadius: "8px"
    },
    ...(day.day() === 0 || day.day() === 1) && {
      "&::after": {
        content: '""',
        zIndex: -1,
        backgroundColor: "var(--mui-palette-brand-main)",
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        borderRadius: "8px"
      }
    }
  }
}));
export {
  DatePickerHeader,
  PickersDayWeekTypeStyled
};
